import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { DisplayText, Button, Stack } from '@shopify/polaris'
import { EmbeddedApp } from '@shopify/polaris/embedded'
import ShopifyAppLayout from 'components/shopifyApp/ShopifyAppLayout'
import styled from 'styled-components'
import { gotoDashboard } from 'controllers/shopifyApp'

import { SHOPIFY_GRAY } from 'components/styles'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${SHOPIFY_GRAY};
  font-size: 14px;
  line-height: 1;
  overflow: scroll;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
`

const InnerWrapper = styled.div`
  width: 100%;
  height: 10em;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
`

class ChargeDeclinedPage extends Component {
  gotoDashboard () {
    gotoDashboard()
  }

  gotoInstructions () {
    const url = 'https://help.shopify.com/manual/apps/working-with-apps#uninstall-an-app'
    window.top.location.href = url
  }

  renderBody () {
    return (
      <Wrapper>
        <InnerWrapper>
          <DisplayText size='large'>Charge was declined</DisplayText>
          <Stack>
            <Button primary onClick={this.gotoDashboard}>Back to Whimm</Button>
            <Button onClick={this.gotoInstructions}>Uninstall instructions</Button>
          </Stack>
        </InnerWrapper>
      </Wrapper>
    )
  }

  renderContent () {
    return (
      <ShopifyAppLayout
        body={this.renderBody()}
      />
    )
  }

  render () {
    const { shopifyAuth } = this.props
    if (shopifyAuth.apiKey && shopifyAuth.shopUrl) {
      return (
        <EmbeddedApp
          apiKey={shopifyAuth.apiKey}
          shopOrigin={`https://${shopifyAuth.shopUrl}`}
        >
          {this.renderContent()}
        </EmbeddedApp>
      )
    } else {
      return this.renderContent()
    }
  }
}

ChargeDeclinedPage.propTypes = {
  shopifyAuth: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  shopifyAuth: state.shopifyAuth
})

export default connect(mapStateToProps)(ChargeDeclinedPage)



// WEBPACK FOOTER //
// ./src/components/pages/ChargeDeclinedPage.js